var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.dialogVisible,
        width: "50%",
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-form-inline",
          attrs: {
            model: _vm.formInfo,
            rules: _vm.rules,
            inline: false,
            "label-width": "120px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "管理员姓名", prop: "name" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.formInfo.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.formInfo, "name", $$v)
                  },
                  expression: "formInfo.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "手机号", prop: "loginName" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.formInfo.loginName,
                  callback: function ($$v) {
                    _vm.$set(_vm.formInfo, "loginName", $$v)
                  },
                  expression: "formInfo.loginName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "密码", prop: "pwd" } },
            [
              _c("el-input", {
                attrs: { type: "pwd" },
                model: {
                  value: _vm.formInfo.pwd,
                  callback: function ($$v) {
                    _vm.$set(_vm.formInfo, "pwd", $$v)
                  },
                  expression: "formInfo.pwd",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "状态", prop: "status" } },
            [
              _c(
                "el-radio",
                {
                  attrs: { label: 1 },
                  model: {
                    value: _vm.formInfo.state,
                    callback: function ($$v) {
                      _vm.$set(_vm.formInfo, "state", $$v)
                    },
                    expression: "formInfo.state",
                  },
                },
                [_vm._v("正常")]
              ),
              _c(
                "el-radio",
                {
                  attrs: { label: 3 },
                  model: {
                    value: _vm.formInfo.state,
                    callback: function ($$v) {
                      _vm.$set(_vm.formInfo, "state", $$v)
                    },
                    expression: "formInfo.state",
                  },
                },
                [_vm._v("禁用")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "right" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("ruleForm")
                    },
                  },
                },
                [_vm._v("确定")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }